'use strict'

module.exports = (data) => JSON.parse(data.toString())



//////////////////
// WEBPACK FOOTER
// ./~/y-ipfs-connector/src/decode.js
// module id = 872
// module chunks = 0